import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#1565C0',
      light: '#B8CDF6',
    },
  },
  typography: {
    h2: {
      fontSize: 20,
      fontWeight: 500,
    },
    body2: {
      fontSize: 17,
    },
  },
  components: {
    MuiDialog: {
      defaultProps: {
        PaperProps: {
          style: {
            borderRadius: 12,
          },
        },
      },
    },
    MuiDialogTitle: {
      defaultProps: {
        borderBottom: '1px solid #D4D6D7',
      },
    },
    MuiDialogContent: {
      defaultProps: {
        style: {
          padding: 24,
        },
      },
    },
    MuiDialogActions: {
      defaultProps: {
        style: {
          padding: 24,
        },
      },
    },
  },
});
